/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LicensingModule
 */

const moduleName = 'licensing';
const componentName = 'disconnect-on-prem-licensing-modal';
const prefix = `${moduleName}.${componentName}`;

export const disconnectOnPremLicensingHeader = `${prefix}.disconnectOnPremLicensingHeader`;
export const recommendedLabel = `${prefix}.recommendedLabel`;
export const recommendedMessage = `${prefix}.recommendedMessage`;
export const kbArticleLinkLabel = `${prefix}.kbArticleLinkLabel`;
export const forceDisconnectMessage = `${prefix}.forceDisconnectMessage`;
export const forceDisconnectCheckboxLabel = `${prefix}.forceDisconnectCheckboxLabel`;
export const cancelButtonLabel = `${prefix}.cancelButtonLabel`;
export const forceDisconnectButtonLabel = `${prefix}.forceDisconnectButtonLabel`;
export const closeBtnLabel = `${prefix}.closeBtnLabel`;

export const ENGLISH = {
    [disconnectOnPremLicensingHeader]: 'Disconnect On-prem License Hub',
    [recommendedLabel]: 'Recommended',
    [recommendedMessage]: 'To ensure proper asset cleanup, it\'s advised to disconnect from On-Prem License Hub.',
    [kbArticleLinkLabel]: 'How to disconnect from On-prem License Hub KB',
    [forceDisconnectMessage]: 'If you\'re experiencing issues with disconnection, you can forcibly disconnect the Controller from On-prem License Hub as a last resort.',
    [forceDisconnectCheckboxLabel]: 'I have tried disconnecting from On-prem License Hub and would like to force disconnect',
    [cancelButtonLabel]: 'CANCEL',
    [forceDisconnectButtonLabel]: 'FORCE DISCONNECT',
    [closeBtnLabel]: 'Close',
};
